import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Alpine from 'alpinejs'
import Splide from 'alpine-splide'
import intersect from '@alpinejs/intersect'
import banner from './alpine/banner'
import slider from './alpine/slider'
import floorplans from './alpine/floorplans'
import tns from './alpine/tns';

Alpine.data('banner', banner)
Alpine.data('slider', slider)
Alpine.data('Splide', Splide)
Alpine.data('floorplans', floorplans)

Alpine.data('tns', tns)

Alpine.plugin(intersect)

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;


const options = {
  linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup]), svg a',
  plugins: [
    new SwupBodyClassPlugin(),
    // new SwupScrollPlugin(),
    // new SwupScriptsPlugin({
    //   optin: true
    // }),
  ],
};

const swup = new Swup(options); 

// Events
swup.on('contentReplaced', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  l('scroll to top');
  window.scrollTo(0,0);
}

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}